/**
 * Created by USER on 18/9/19.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Input, Modal, message} from 'antd';
import ImgList from '../images/img';
import AffiliateModal from '../component/affiliates_TC';
import httpClient from '../swagger/affiliate_swagger';
import {changeBarState} from '../redux/actions/headerbar_action';

const { client } = httpClient;
const { TextArea } = Input;

class AllianceUser extends Component {
  constructor(props) {
    super(props);
    const url = 'https://www.lubanso.com/t/';
    this.state = {
      emailErrorDisplay: 'none', //邮箱的错误提示
      addressErrorDisplay: 'none', //比特币地址的错误提示
      inputValue: {
        email: '',
        address: ''
      },
      updateText: '',
      affiliateModal: false, // 联盟条款的modal
      withdrawalModal: false, // 提现modal
      withdrawal: null,
      withdrawalErrorDisplay: 'none', // 提现金额的错误提示,
      withdrawal_button_text: this.props.t('apply_withdrawals'),
      withdrawalRecordModal: false,
      securityCode: null, //登录号
      orderList: {
        balance_money: 'N/A',
        total_money: 'N/A',
        total_order: 'N/A',
        commission_money: 'N/A'
      },
      settleList: [], // 提现历史
      price_cny: null,
      withDraWalBTC: 'N/A',
      infoCode: null,
      historyPage: 1,
      nextPage: true,
      textarea300x250: `<a href=${url} ><img width=300 height=250 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/300x250.jpg"></a>`,
      textarea468x60: `<a href=${url} ><img width=468 height=60 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/468x60.jpg"></a>`,
      textarea320x50: `<a href=${url} ><img width=320 height=50 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/320x50.jpg"></a>`,
      textarea728x90: `<a href=${url} ><img width=728 height=90 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/728x90.jpg"></a>`,
      textarea850x420: `<a href=${url} ><img width=850 height=420 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/850x420.jpg"></a>`,
      textarea160x600: `<a href=${url} ><img width=160 height=600 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/160x600.jpg"></a>`,
      textarea300x600: `<a href=${url} ><img width=300 height=600 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/300x600.jpg"></a>`,
      qrcode: null,
      address: null
    }
  }

  componentWillMount() {
    this.props.dispatch(changeBarState('affiliates'));
    this.getMemberInfo(); // 获取用户的信息
    this.getOrderList(); // 获取用户推广订单的信息
  }
  componentDidMount() { // 滚至最顶部
    this.setState({
      updateText: this.props.t('submit_change')
    })
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);

    window.addEventListener("popstate", () => {
      location.replace("/");
    }, true);
  }

  getMemberInfo() { //获取用户的基本信息
    client.then((oclient) => {
      oclient.apis.member.get_member_info({}).then((result) => {
        if (result.obj.code === 200) {
          const data = result.obj.data;
          if (window.location.pathname !== `/affiliates/${data.code}`) {
            this.props.history.push('/');
          }

          const url = `https://www.lubanso.com/t/?id=${data.tracking_code}`;
          this.setState({
            inputValue: {
              email: data.email,
              address: data.btc_wallet
            },
            securityCode: data.security_code,
            infoCode: data.tracking_code,
            textarea300x250: `<a href=${url} ><img width=300 height=250 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/300x250.jpg"></a>`,
            textarea468x60: `<a href=${url} ><img width=468 height=60 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/468x60.jpg"></a>`,
            textarea320x50: `<a href=${url} ><img width=320 height=50 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/320x50.jpg"></a>`,
            textarea728x90: `<a href=${url} ><img width=728 height=90 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/728x90.jpg"></a>`,
            textarea850x420: `<a href=${url} ><img width=850 height=420 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/850x420.jpg"></a>`,
            textarea160x600: `<a href=${url} ><img width=160 height=600 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/160x600.jpg"></a>`,
            textarea300x600: `<a href=${url} ><img width=300 height=600 alt="lubanso" src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/web/promo/lubanso-x1/300x600.jpg"></a>`,
            qrcode: data.wx_qr_code,
            address: data.btc_wallet
          })
        } else {
          message.error(result.obj.message);
          this.props.history.push('/affiliates')
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  getOrderList() { // 获取用户推广订单的信息
    client.then((oclient) => {
      oclient.apis.order.get_order_list({}).then((result) => {
        if (result.obj.code === 200) {
          const data = result.obj;
          this.setState({
            orderList: {
              balance_money: data.balance_money,
              total_money: data.total_money,
              total_order: data.total_order,
              commission_money: data.commission_money
            }
          })
        }else {
          message.error(result.obj.message)
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  getSettleList(page) { // 获取提现的历史
    client.then((oclient) => {
      oclient.apis.settlement.get_settle_list({
        page,
        limit: 6
      }).then((result) => {
        if (result.obj.code === 200) {
          this.setState({
            settleList: result.obj.data,
            historyPage: page,
            nextPage: result.obj.data.length === 6
          });
        }else {
          message.error(result.obj.message)
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  submit() {
    const {inputValue} = this.state;
    const emailReg = /^(\w)+(\.?\w+)@(\w)+((\.\w{2,3}){1,3})$/;
    const addressReg= /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/;
    const email = emailReg.test(inputValue.email.replace(/^\s+|\s+$/g, ''));
    const address = inputValue.address ? addressReg.test(inputValue.address.replace(/^\s+|\s+$/g, '')) : null;
    if (email && address !== false) {
      this.setState({
        updateText: this.props.t('submit_loading')
      });
      let obj = {
        email: inputValue.email,
        btc_wallet: inputValue.address
      };
      if (address === null) {
        delete obj.btc_wallet;
      }
      client.then((oclient) => {
        oclient.apis.member.put_member_info(obj).then((result) => {
          if (result.obj.code === 200) {
            message.success(result.obj.message);
            this.setState({
              address: inputValue.address
            })
          }else {
            message.error(result.obj.message)
          }
          this.setState({
            updateText: this.props.t('submit_change')
          })
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    }
    if (!email) {
      this.setState({
        emailErrorDisplay: 'block'
      })
    }
    if (address === false) {
      this.setState({
        addressErrorDisplay: 'block'
      })
    }
  }

  emailOnchange(e) { // 邮箱表单的onchange事件
    const {inputValue} = this.state;
    this.setState({
      emailErrorDisplay:'none',
      inputValue: {
        email: e.target.value,
        address: inputValue.address
      }
    })
  }

  addressOnchange(e) { // BTC 地址的onchange事件
    const {inputValue} = this.state;
    this.setState({
      addressErrorDisplay: 'none',
      inputValue: {
        email: inputValue.email,
        address: e.target.value
      }
    })
  }

  handleCancel() { // 隐藏联盟条款
    this.setState({
      affiliateModal: false,
      withdrawalModal: false,
      withdrawalRecordModal: false,
      historyPage: 1
    })
  }

  logOut() { // 退出登录呢
    client.then((oclient) => {
      oclient.apis.member.post_member_login_out({}).then((result) => {
        if (result.obj.code === 200) {
          this.props.history.push('/affiliates');
        }else {
          message.error(result.obj.message)
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  withdrawalOnchange(e) { // 提现的input onchange事件
    const {price_cny} = this.state;
    this.setState({
      withdrawalErrorDisplay: 'none',
      withdrawal: e.target.value,
      withDraWalBTC: (e.target.value / price_cny) === 0 ? 'N/A' : (e.target.value / price_cny).toFixed(8)
    });
  }

  withdrawal() { // 提现
    const {withdrawal, price_cny} = this.state;
    if (/^[0-9]+(.[0-9]{0,2})?$/.test(withdrawal)) {
      this.setState({
        withdrawal_button_text: this.props.t('apply_withdrawals_loading')
      });
      client.then((oclient) => {
        oclient.apis.settlement.put_settle_apply({
          money: withdrawal,
          ticker: price_cny
        }).then((result) => {
          if (result.obj.code === 200) {
            this.setState({
              withdrawalModal: false
            });
            this.getOrderList();
            message.success(this.props.t('apply_withdrawals_did'))
          } else if (result.obj.code === -13105) {
            message.error(result.obj.message);
            this.getWithDrawal();
          }else {
            message.error(result.obj.message)
          }
          this.setState({
            withdrawal_button_text: this.props.t('apply_withdrawals')
          })
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    } else {
      this.setState({
        withdrawalErrorDisplay: 'block'
      })
    }
  }

  getWithDrawal() { // 获取汇率
    const {address} = this.state;
    if (address) {
      this.setState({withdrawalModal: true});
      client.then((oclient) => {
        oclient.apis.public.get_public_ticker_crypto_currency_fiat_currency({
          crypto_currency: 'BTC',
          fiat_currency: 'CNY'
        }).then((result) => {
          if (result.obj.code === 200) {
            this.setState({
              price_cny: Number(result.obj.data.price)
            })
          } else {
            message.error(result.obj.message)
          }
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    } else  {
      message.error(this.props.t('set_BTC_address'))
    }
  }

  textAreaOnchange(e, type) { // 文本域的change事件
    this.setState({
      [type]: e.target.value
    })
  }

  componentWillReceiveProps(nextProps){ // state发生改变 需要执行的操作
    if (this.props.appBarReducer.language !== nextProps.appBarReducer.language) {
      this.setState({
        updateText: this.props.t('submit_change')
      })
    }
  }

  render() {
    const { t } = this.props;
    const {emailErrorDisplay, addressErrorDisplay, inputValue, updateText, affiliateModal, withdrawalModal,
      withdrawalErrorDisplay, withdrawal_button_text, withdrawalRecordModal, securityCode, orderList,
      settleList, price_cny, withDraWalBTC, infoCode, textarea300x250, textarea320x50, textarea468x60,
      textarea728x90, textarea850x420, textarea160x600, textarea300x600, historyPage, nextPage, qrcode
    } = this.state;
    return (
      <div className="alliance_user">
        <div className="alliance_user_information">
          <div>
            <div className="alliance_user_account">
              <h2>{t('affiliate_account')}</h2>
              <p>{t('affiliate_account_notice')}</p>
              <ul>
                <li>
                  <span>{t('affiliate_account_amount')}</span>
                  <span>
                    ￥
                    {orderList.balance_money === 'N/A' ? 'N/A' : Number(orderList.balance_money).toFixed(2) === '0.00' ? 0 :
                        Number(orderList.balance_money).toFixed(2)}
                </span>
                </li>
                <li><span>{t('affiliate_account_order')}</span><span>{orderList.total_order}</span></li>
                <li>
                  <span>{t('affiliate_account_total_amount')}</span>
                  <span>{
                    orderList.commission_money === 'N/A' ? 'N/A' : Number(orderList.commission_money).toFixed(2) === '0.00' ? 0 :
                        Number(orderList.commission_money).toFixed(2)}
                  </span>
                </li>
              </ul>
              <div className="alliance_user_account_switch">
                <p>{t('affiliate_account_notice1')}</p>
                <div>
                <span
                  onClick={() => this.getWithDrawal()}
                >{t('affiliate_account_button')}</span>
                  <span
                    onClick={() => {this.setState({withdrawalRecordModal: true}); this.getSettleList(1);}}
                  >{t('affiliate_account_button1')}</span>
                </div>
              </div>
            </div>
            {
              qrcode ?
                <div className="alliance_qrcode">
                  <img src={qrcode} alt="lubanso" />
                  <div>
                    <p>{t('affiliate_user_Flicking')}</p>
                    <san>{t('affiliate_user_Flicking_notice')}</san>
                  </div>
                </div> : false
            }
          </div>
          <div>
            <div className="alliance_user_title">
              <h2>{t('affiliate_user_title')}</h2>
              <span
                onClick={() => this.setState({affiliateModal: true})}
              >{t('affiliate_user_agreement')}
              </span>
              <span
                onClick={() => this.logOut()}
              >{t('affiliate_user_login_out')}</span>
            </div>
            <div className="alliance_user_details">
              <div className="login_id">
                <p>{t('affiliate_user_login_code')}</p>
                <Input
                  value={securityCode}
                />
                <span>{t('affiliate_login_code_notice')}</span>
              </div>
              <div>
                <p>{t('affiliate_user_information')}</p>
                <span
                  className="input_error"
                  style={{display: emailErrorDisplay}}
                >
                  {t('error_email')}
                </span>
                <Input
                  value={inputValue.email}
                  onChange={e => this.emailOnchange(e)}
                  style={{borderColor: emailErrorDisplay === 'none' ? '#d9d9d9' : '#e4393c' }}
                />
                <span
                  className="input_error"
                  style={{display: addressErrorDisplay}}
                >
                  {t('error_address')}
                </span>
                <Input
                  placeholder={t('address_placeholder')}
                  value={inputValue.address}
                  onChange={e => this.addressOnchange(e)}
                  style={{borderColor: addressErrorDisplay === 'none' ? '#d9d9d9' : '#e4393c' }}
                />
                <span className="info_notice">{t('affiliate_user_information_notice')}</span>
                <div className="update_button">
                  <span
                    onClick={() => this.submit()}
                  >{updateText}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tracking">
          <h2 className="tracking_title">{t('affiliate_tracking')}</h2>
          <div className="single_tracking">
            <Input
              value={`https://www.lubanso.com/t/?id=${infoCode}`}
            />
            <p>{t('affiliate_tracking_notice')}</p>
          </div>
          <div className="single_tracking">
            <Input
              value={`https://www.lubanso.com/t/X1/?id=${infoCode}`}
            />
            <p>{t('affiliate_tracking_notice1')}</p>
          </div>
        </div>
        <div className="tracking_banner">
          <h2 className="tracking_title">{t('affiliate_tracking_banner')}</h2>
          <p className="tracking_notice">{t('affiliate_tracking_banner_notice')}</p>
          <div>
            <div className="single_tracking_banner racking_banner300x250">
              <b>300 x 250</b>
              <br />
              <img src={ImgList.img.banner300x250} alt="lubanso" />
              <TextArea
                value={textarea300x250}
                rows={4}
                onChange={(e) => this.textAreaOnchange(e, 'textarea300x250')}
              />
            </div>
            <div className="right_tracking_banner">
              <div className="single_tracking_banner racking_banner468x60">
                <b>468 x 60</b>
                <br />
                <img src={ImgList.img.banner468x60} alt="lubanso" />
                <TextArea
                  value={textarea468x60}
                  rows={4}
                  onChange={(e) => this.textAreaOnchange(e, 'textarea468x60')}
                />
              </div>
              <div className="single_tracking_banner racking_banner320x50">
                <b>320 x 50</b>
                <br />
                <img src={ImgList.img.banner320x50} alt="lubanso" />
                <TextArea
                  value={textarea320x50}
                  rows={4}
                  onChange={(e) => this.textAreaOnchange(e, 'textarea320x50')}
                />
              </div>
            </div>
          </div>
          <div>
            <div className="single_tracking_banner racking_banner728x90">
              <b>728 x 90</b>
              <br />
              <img src={ImgList.img.banner728x90} alt="lubanso" />
              <TextArea
                value={textarea728x90}
                rows={4}
                onChange={(e) => this.textAreaOnchange(e, 'textarea728x90')}
              />
            </div>
          </div>
          <div>
            <div className="single_tracking_banner racking_banner850x420">
              <b>850 x 420</b>
              <br />
              <img src={ImgList.img.banner850x420} alt="lubanso" />
              <TextArea
                value={textarea850x420}
                rows={4}
                onChange={(e) => this.textAreaOnchange(e, 'textarea850x420')}
              />
            </div>
          </div>
          <div>
            <div className="single_tracking_banner racking_banner160x600">
              <b>160 x 600</b>
              <br />
              <img src={ImgList.img.banner160x600} alt="lubanso" />
              <TextArea
                value={textarea160x600}
                rows={4}
                onChange={(e) => this.textAreaOnchange(e, 'textarea160x600')}
              />
            </div>
            <div className="single_tracking_banner racking_banner300x600">
              <b>300 x 600</b>
              <br />
              <img src={ImgList.img.banner300x600} alt="lubanso" />
              <TextArea
                value={textarea300x600}
                rows={4}
                onChange={(e) => this.textAreaOnchange(e, 'textarea300x600')}
              />
            </div>
          </div>
        </div>
        <AffiliateModal
          show={affiliateModal}
          handleCancel={() => this.handleCancel()}
          t={t}
        />
        <Modal
          visible={withdrawalModal}
          footer={null}
          onCancel={() => this.handleCancel()}
          destroyOnClose={true}
        >
          <div>
            <p className="withdrawal_title">{t('withdrawals_amount')}: <span>{t('affiliate_account_amount')}: ￥{
              orderList.balance_money === 'N/A' ? 'N/A' : Number(orderList.balance_money).toFixed(2) === '0.00' ? 0 :
                  Number(orderList.balance_money).toFixed(2)
            }</span></p>
            <span
              className="input_error"
              style={{display: withdrawalErrorDisplay}}
            >
              {t('withdrawals_amount_error')}
            </span>
            <Input
              placeholder={`${t('withdrawals_total')}${
                orderList.balance_money === 'N/A' ? 'N/A' : Number(orderList.balance_money).toFixed(2) === '0.00' ? 0 :
                    Number(orderList.balance_money).toFixed(2)
                }${t('withdrawals_cny')}`}
              onChange={e => this.withdrawalOnchange(e)}
              type="number"
              style={{borderColor: withdrawalErrorDisplay === 'none' ? '#d9d9d9' : '#e4393c' }}
            />
            <div className="withdrawal_rate">
              <span>1BTC = <b>￥{price_cny ? price_cny.toFixed(2) : 'N/A'}</b></span>
              <span>{t('withdrawal_rate')}：<b>{withDraWalBTC}</b> {t('withdrawal_rate1')}</span>
            </div>
            <div className="withdrawal_notice">{t('withdrawal_rate_notice')}</div>
            <div className="withdrawal_button">
              <span
                onClick={() => this.withdrawal()}
              >{withdrawal_button_text}</span>
            </div>
          </div>
        </Modal>
        <Modal
          visible={withdrawalRecordModal}
          footer={null}
          onCancel={() => this.handleCancel()}
          destroyOnClose={true}
          width={700}
        >
          <div>
            <div className="settle_table">
              <table className="record_table">
                <tr>
                  <th>{t('record_table_th1')}</th>
                  <th>{t('record_table_th2')}</th>
                  <th>{t('record_table_th3')}</th>
                  <th>{t('record_table_th4')}</th>
                  <th>{t('record_table_th5')}</th>
                  <th>{t('record_table_th6')}</th>
                </tr>
                {
                  settleList.map((item, index) => (
                    <tr>
                      <td>{historyPage === 1 ? (index + 1) : 6 * (historyPage - 1 ) + (index +1)}</td>
                      <td>{item.date_created}</td>
                      <td>{item.money}</td>
                      <td>{(item.cny_ticker).toFixed(2)}</td>
                      <td>{(item.btc_money).toFixed(8)}</td>
                      <td
                        style={{color: item.status === 1 ? '#0085ff' : item.status === 2 ?
                            'rgba(0, 0, 0, 0.65)' : '#E4393c'}}
                      >{item.status === -1 ? t('record_state_Refused') : item.status === 0 ? t('record_state_withdrawn') :
                          item.status === 1 ? t('record_state_auditing') : t('record_state_audited')}
                      </td>
                    </tr>
                  ))
                }
              </table>
            </div>
            <div className="record_switch">
              <i
                className="icon iconfont icon-ArtboardCopy1"
                onClick={() => this.getSettleList(historyPage - 1)}
                style={{color: historyPage === 1 ? '#ddd' : 'rgba(0, 0, 0, 0.65)',
                  pointerEvents: historyPage === 1 ? 'none' : 'auto'
                }}
              />
              <i>{historyPage}</i>
              <i
                className="icon iconfont icon-ArtboardCopy"
                onClick={() => this.getSettleList(historyPage + 1)}
                style={{color: !nextPage ? '#ddd' : 'rgba(0, 0, 0, 0.65)',
                  pointerEvents: !nextPage ? 'none' : 'auto'
                }}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}


function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const AllianceUserConnected = connect(select)(AllianceUser);

export default translate('translations')(AllianceUserConnected);